/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_rDolar_114_36(e) {
  let t = (0, ReactCompiler.c)(8),
    { parte: n, total: r, tono: i } = e,
    a = i === void 0 ? `accent` : i,
    o;
  t[0] !== n || t[1] !== r
    ? ((o = r > 0 ? Math.max(2, Math.round((n / r) * 100)) : 0),
      (t[0] = n),
      (t[1] = r),
      (t[2] = o))
    : (o = t[2]);
  let s = `${o}%`,
    c;
  t[3] === s
    ? (c = t[4])
    : ((c = {
        width: s,
      }),
      (t[3] = s),
      (t[4] = c));
  let l = `h-full rounded-full ${a === `error` ? `bg-(--error)` : `bg-(--accent)`}`,
    u;
  return (
    t[5] !== c || t[6] !== l
      ? ((u = (
          <div
            className={`h-1.5 w-full overflow-hidden rounded-full bg-(--panel)`}
            children={<div style={c} className={l} />}
          />
        )),
        (t[5] = c),
        (t[6] = l),
        (t[7] = u))
      : (u = t[7]),
    u
  );
}
